<div class="container-notifications" data-testid="container-notifications">
  <div class="container-invoices" data-testid="container-invoices">
    <div class="title-invoices-container">
      <h4 class="title-invoices" data-testid="title-invoices">Synthèse des factures à envoyer</h4>
    </div>

    @if (loading) {
      <div class="spinner-wrapper">
        <app-spinner [mainColor]="Color.primary600" [secondColor]="Color.white" [diameter]="'2rem'"></app-spinner>
      </div>
    } @else {
      @if (error) {
        <div class="error-alerts" data-testid="error-alerts">
          <app-report-message
            [type]="alertLogLevel.ERROR"
            [message]="'Merci de rafraîchir la page. Si le problème persiste merci de prévenir les équipes.'"
            data-testid="app-report-error-message"
          ></app-report-message>
        </div>
      } @else {
        <div class="d-flex justify-space-around" data-testid="invoices-summary">
          <div data-testid="invalid-invoices">
            <div class="d-flex positionnement-icon-text">
              <app-icon phosphorClass="ph-x" [color]="Color.danger500" data-testid="icon-invalid"></app-icon>
              <span class="spacement" data-testid="invalid-invoices-count">
                <b>{{ invoicesInformations.invalidInvoices }}</b>
              </span>
            </div>
            <span class="spacement font-s-14">
              <b>{{ invoicesInformations.invalidInvoices > 1 ? 'Invalides' : 'Invalide' }}</b>
            </span>
          </div>

          <hr />

          <div data-testid="valid-invoices">
            <div class="d-flex positionnement-icon-text">
              <app-icon phosphorClass="ph-check" [color]="Color.success500" data-testid="icon-valid"></app-icon>
              <span class="spacement" data-testid="valid-invoices-count">
                <b>{{ invoicesInformations.valideInvoices }}</b>
              </span>
            </div>
            <span class="font-s-14">
              <b>{{ invoicesInformations.valideInvoices > 1 ? 'Valides' : 'Valide' }}</b>
            </span>
          </div>

          <hr />

          <div data-testid="total-invoices">
            <div class="d-flex positionnement-icon-text">
              <app-icon phosphorClass="ph-invoice" data-testid="icon-total"></app-icon>
              <span class="spacement" data-testid="total-invoices-count">
                <b>{{ invoicesInformations.totalInvoices }}</b>
              </span>
            </div>
            <span class="font-s-14"><b>Total</b></span>
          </div>
        </div>
      }
    }
  </div>
</div>
